/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Transcript_Export_Include_Reply_CheckInputs */



/**
* | output |
* | --- |
* | "Include Reply Checked" |
*
* @param {Transcript_Export_Include_Reply_CheckInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const transcript_export_include_reply_check = /** @type {((inputs?: Transcript_Export_Include_Reply_CheckInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Transcript_Export_Include_Reply_CheckInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Include Reply Checked")
	if (locale === "de") return /** @type {LocalizedString} */ ("Include Reply Checked")
	if (locale === "it") return /** @type {LocalizedString} */ ("Include Reply Checked")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Include Reply Checked")
	if (locale === "es") return /** @type {LocalizedString} */ ("Include Reply Checked")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Include Reply Checked")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Include Reply Checked")
	if (locale === "hi") return /** @type {LocalizedString} */ ("Include Reply Checked")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Include Reply Checked")
	return /** @type {LocalizedString} */ ("Include Reply Checked")
});